var _linearGradient, _circle, _g, _linearGradient2, _circle2, _g2, _linearGradient3, _circle3, _radialGradient, _circle4, _linearGradient4, _circle5, _linearGradient5, _path, _linearGradient6, _circle6, _radialGradient2, _circle7, _linearGradient7, _use, _linearGradient8, _use2, _linearGradient9, _use3, _linearGradient0, _use4, _linearGradient1, _use5, _linearGradient10, _use6, _path2, _use7, _use8, _path3, _use9, _use0, _path4, _use1, _use10, _path5, _linearGradient11, _use11, _linearGradient12, _use12, _path6, _linearGradient13, _path7, _linearGradient14, _path8, _path9, _linearGradient15, _use13, _linearGradient16, _use14, _path0, _use15, _path1, _linearGradient17, _path10, _linearGradient18, _path11, _linearGradient19, _path12, _linearGradient20, _use16, _linearGradient21, _path13, _linearGradient22, _use17, _linearGradient23, _path14, _linearGradient24, _use18, _g3, _g4, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVipIconBg = function SvgVipIconBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 558.8 579.6",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 579.576,
    x2: 279.402,
    y2: 20.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 300.2,
    r: 279.4,
    fill: "url(#A)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 20.773,
    x2: 279.402,
    y2: 579.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 21.8c37.6 0 74 7.4 108.4 21.9 33.2 14 62.9 34.1 88.5 59.7s45.6 55.3 59.7 88.5c14.5 34.3 21.9 70.8 21.9 108.4s-7.4 74-21.9 108.4c-14 33.2-34.1 62.9-59.7 88.5s-55.3 45.6-88.5 59.7c-34.3 14.5-70.8 21.9-108.4 21.9s-74-7.4-108.4-21.9c-33.2-14-62.9-34.1-88.5-59.7s-45.6-55.3-59.7-88.5C8.4 374.2 1 337.8 1 300.2s7.4-74 21.9-108.4c14-33.2 34.1-62.9 59.7-88.5s55.3-45.6 88.5-59.7c34.3-14.5 70.7-21.8 108.3-21.8m0-1C125.1 20.8 0 145.9 0 300.2s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 20.8 279.4 20.8z",
    fill: "url(#B)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 558.803,
    x2: 279.402,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 279.4,
    fill: "url(#C)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 0,
    x2: 279.402,
    y2: 558.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fce2ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc9a11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.4 3c37.3 0 73.5 7.3 107.6 21.7 32.9 13.9 62.5 33.9 87.9 59.2 25.4 25.4 45.3 54.9 59.2 87.9 14.4 34.1 21.7 70.3 21.7 107.6s-7.3 73.5-21.7 107.6c-13.9 32.9-33.9 62.5-59.2 87.9-25.4 25.4-54.9 45.3-87.9 59.2-34.1 14.4-70.3 21.7-107.6 21.7s-73.5-7.3-107.6-21.7c-32.9-13.9-62.5-33.9-87.9-59.2C58.5 449.5 38.6 420 24.7 387 10.3 352.9 3 316.7 3 279.4s7.3-73.5 21.7-107.6C38.6 138.9 58.6 109.3 84 84c25.4-25.4 54.9-45.3 87.9-59.2C205.9 10.3 242.1 3 279.4 3m0-3C125.1 0 0 125.1 0 279.4s125.1 279.4 279.4 279.4 279.4-125.1 279.4-279.4S433.7 0 279.4 0z",
    fill: "url(#D)"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 552.571,
    x2: 279.402,
    y2: 6.232
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#E)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: 279.402,
    cy: 279.402,
    r: 273.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 273.2,
    fill: "url(#F)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 526.604,
    x2: 279.402,
    y2: 32.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 247.2,
    fill: "url(#G)"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 32.199,
    x2: 279.402,
    y2: 526.604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7b53c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.4 33.7c33.2 0 65.3 6.5 95.6 19.3 29.3 12.4 55.5 30.1 78.1 52.7s40.3 48.8 52.7 78.1c12.8 30.3 19.3 62.5 19.3 95.6s-6.5 65.3-19.3 95.6c-12.4 29.3-30.1 55.5-52.7 78.1s-48.8 40.3-78.1 52.7c-30.3 12.8-62.5 19.3-95.6 19.3s-65.3-6.5-95.6-19.3c-29.3-12.4-55.5-30.1-78.1-52.7S65.4 404.3 53 375c-12.8-30.3-19.3-62.5-19.3-95.6s6.5-65.3 19.3-95.6c12.4-29.3 30.1-55.5 52.7-78.1s48.8-40.3 78.1-52.7c30.3-12.8 62.4-19.3 95.6-19.3m0-1.5c-136.5 0-247.2 110.7-247.2 247.2s110.7 247.2 247.2 247.2 247.2-110.7 247.2-247.2S415.9 32.2 279.4 32.2z",
    fill: "url(#H)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 279.402,
    y1: 505.831,
    x2: 279.402,
    y2: 52.972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c7c7c"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#I)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 279.402,
    cy: 279.402,
    r: 226.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopOpacity: 0.515
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 279.4,
    r: 226.4,
    fill: "url(#J)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.299,
    x2: 225.391,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#K)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.294,
    x2: 225.391,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    fill: "url(#L)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 225.388,
    y1: 128.299,
    x2: 225.388,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: 64.4,
    fill: "url(#M)"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 128.294,
    x2: 289.788,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#N)"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.299,
    x2: 352.108,
    y2: 84.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#O)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.294,
    x2: 352.108,
    y2: 84.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "url(#P)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#K)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    fill: "url(#L)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 88.8l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    x: 64.4,
    fill: "url(#M)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p",
    fill: "url(#N)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 88.8l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    opacity: 0.5
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    fill: "url(#O)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    fill: "url(#P)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1 429.5l5.5 17.1h16.6L234.7 457l3.9 16.1-13.5-7.4-13.5 7.4L216 457l-12.4-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.294,
    x2: 225.391,
    y2: 84.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    y: 340.7,
    fill: "url(#Q)"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 225.391,
    y1: 128.276,
    x2: 225.391,
    y2: 84.652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    y: 340.7,
    fill: "url(#R)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 429.5l5.5 17.1h16.6L299.1 457l3.9 16.1-13.5-7.4-13.5 7.4 4.4-16.1-12.4-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 468.994,
    x2: 289.788,
    y2: 425.368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 425.4l5.5 17.1h16.6l-12.5 10.4L303 469l-13.5-7.5L276 469l4.4-16.1-12.4-10.4h16.6z",
    fill: "url(#S)"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 289.788,
    y1: 468.976,
    x2: 289.788,
    y2: 425.352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 426.4l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4L276 469l13.5-7.5L303 469l-3.9-16.1 12.5-10.4H295l-5.5-17.1z",
    fill: "url(#T)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M351.8 429.5l5.5 17.1h16.6L361.5 457l3.8 16.1-13.5-7.4-13.4 7.4 4.4-16.1-12.5-10.4h16.6z",
    opacity: 0.5
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.294,
    x2: 352.108,
    y2: 84.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    y: 340.7,
    fill: "url(#U)"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 352.108,
    y1: 128.276,
    x2: 352.108,
    y2: 84.652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    y: 340.7,
    fill: "url(#V)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6 226h38.3l-56.4 185.3h-40.7L112 226h39l21 81.9c5.5 21.9 11.1 44.1 14.9 66.5h.7c4.1-22.2 9.6-44.8 15.4-66.5l21.6-81.9zm57.3 185.3V226h35.7v185.3h-35.7zm71.8 0V228.4c11.6-2.2 27.5-3.9 48-3.9 23.4 0 41 4.6 52.8 14.7 11.1 9.4 17.8 24.3 17.8 41.4 0 50.8-42.4 62.2-70.1 62.2-5.1 0-9.4-.2-13-1v69.4h-35.5zm35.4-97.3c3.4.7 7.2 1 12.5 1 22.2 0 35.2-12.5 35.2-32.5 0-19.8-12.5-30.1-32.3-30.1-7.2 0-12.3.7-15.4 1.4V314z"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 214.9h-11.4v-49h-19.7v-9.8h51v9.8h-19.9v49zm57.6 0l-4.9-16.1h-19.5l-4.7 16.1h-11.7l19.3-58.9h14.1l19.6 58.9h-12.2zm-15-50c-.9 3.6-2 7.2-2.9 10.5l-4.7 14.7H282l-4.8-14.8c-1-3.2-2.2-7.1-3-10.4h-.1zm35.2 50V156h11.4v23.4h22.4V156h11.4v58.9h-11.4v-25.5h-22.4v25.5h-11.4zM411.4 156v58.9H401v-19c0-10 .2-18.2.6-25.3l-.3-.1c-2.9 6.3-6.3 13.6-9.6 19.7L378 214.8h-11.5V156h10.4v18.4c0 9.3-.3 17.5-1 24.9h.2c2.7-6.1 5.9-12.9 9.3-19l13.5-24.3h12.5z"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 187.449,
    y1: 407.158,
    x2: 187.449,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6 221.9h38.3l-56.4 185.3h-40.7L112 221.9h39l21 81.9c5.5 21.9 11.1 44.1 14.9 66.5h.7c4.1-22.2 9.6-44.8 15.4-66.5l21.6-81.9z",
    fill: "url(#W)"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 299.739,
    y1: 407.158,
    x2: 299.739,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M281.9,407.2V221.9h35.7v185.3H281.9z",
    fill: "url(#X)"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 412.992,
    y1: 407.158,
    x2: 412.992,
    y2: 220.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.7 407.2V224.3c11.6-2.2 27.5-3.9 48-3.9 23.4 0 41 4.6 52.8 14.7 11.1 9.4 17.8 24.3 17.8 41.4 0 50.8-42.4 62.2-70.1 62.2-5.1 0-9.4-.2-13-1v69.4h-35.5zm35.4-97.4c3.4.7 7.2 1 12.5 1 22.2 0 35.2-12.5 35.2-32.5 0-19.8-12.5-30.1-32.3-30.1-7.2 0-12.3.7-15.4 1.4v60.2z",
    fill: "url(#Y)"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 168.214,
    y1: 215.513,
    x2: 168.214,
    y2: 155.16
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -4.1,
    fill: "url(#Z)"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 225.909,
    y1: 210.731,
    x2: 225.909,
    y2: 151.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 210.7h-11.4v-49h-19.7V152h51v9.8h-19.9v48.9z",
    fill: "url(#a)"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 274.727,
    y1: 210.731,
    x2: 274.727,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    fill: "url(#b)"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 331.853,
    y1: 210.731,
    x2: 331.853,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M309.3,210.7v-58.9h11.4v23.4h22.4v-23.4h11.4v58.9h-11.4v-25.5h-22.4v25.5H309.3z",
    fill: "url(#c)"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 388.979,
    y1: 210.731,
    x2: 388.979,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdd53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fcd247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#d58a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f1c740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fce9ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7b53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8dd59"
  }))), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#d)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 187.449,
    y1: 407.158,
    x2: 187.449,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.8 222.7l-55.9 183.7h-39.5l-53.3-183.7h37.4l20.8 81.3c5.1 20.3 10.9 43.3 14.9 66.4l.1.7h2.1l.1-.7c3.6-19.2 8.5-40.4 15.4-66.4l21.3-81.3h36.6m1.1-.8h-38.3l-21.4 81.9c-5.8 21.7-11.3 44.3-15.4 66.5h-.8c-3.9-22.4-9.4-44.6-14.9-66.5l-21-81.9h-39l53.7 185.3h40.7l56.4-185.3z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 299.739,
    y1: 407.158,
    x2: 299.739,
    y2: 221.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.8 222.7v183.7h-34.1V222.7h34.1m.8-.8h-35.7v185.3h35.7V221.9z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 412.992,
    y1: 407.158,
    x2: 412.992,
    y2: 220.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M401.7 221.2c23.8 0 40.9 4.7 52.3 14.5 11.2 9.5 17.5 24.3 17.5 40.8 0 22.3-8.2 38.9-24.3 49.5-15.8 10.3-35 11.9-45 11.9-5.5 0-9.6-.3-12.9-.9l-1-.2v69.6h-33.8V224.9c13.3-2.4 29.6-3.7 47.2-3.7m0 90.4c22.2 0 36-12.8 36-33.3 0-19.7-12.1-30.9-33.1-30.9-7.6 0-12.7.8-15.6 1.5l-.6.1v61.4l.6.1c3.2.8 6.9 1.1 12.7 1.1m0-91.2c-20.5 0-36.4 1.7-48 3.9v182.9h35.4v-69.4c3.6.7 8 1 13 1 27.7 0 70.1-11.3 70.1-62.2 0-17.1-6.7-32-17.8-41.4-11.8-10.2-29.4-14.8-52.7-14.8zm0 90.4c-5.3 0-9.2-.2-12.5-1v-60.2c3.1-.7 8.2-1.4 15.4-1.4 19.8 0 32.3 10.4 32.3 30.1-.1 19.9-13.1 32.5-35.2 32.5z",
    fill: "url(#g)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: -4.1,
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 168.214,
    y1: 211.413,
    x2: 168.214,
    y2: 151.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177 151.9c6.8 0 11.9 1.3 14.4 2.4l-2.2 7.7c-3.8-1.5-7.8-2.3-12.1-2.3-13.4 0-22.1 8.5-22.1 21.7 0 12.9 8.7 21.2 22.1 21.2 4.4 0 8.9-.7 12.1-2l1.6 7.6c-2.7 1.2-8 2.4-15.3 2.4-9.6 0-17.5-2.8-23-8.1-5.2-5.1-7.9-12.1-7.9-20.5.2-18 13.2-30.1 32.4-30.1m0-.8c-19.1 0-33.1 12.1-33.1 30.9 0 17 11.2 29.4 31.7 29.4 7.7 0 13.5-1.4 16.2-2.7l-2-9.2c-3.2 1.4-8 2.3-12.7 2.3-13.5 0-21.3-8.3-21.3-20.4 0-13.3 9.2-20.9 21.3-20.9 5.4 0 9.6 1.3 12.6 2.6l2.6-9.2c-2.4-1.4-7.9-2.8-15.3-2.8z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 210.7h-11.4v-49h-19.7V152h51v9.8h-19.9v48.9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 225.909,
    y1: 210.731,
    x2: 225.909,
    y2: 151.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.6 152.8v8.2h-19.9v49h-9.8v-49h-19.7v-8.2h49.4m.8-.8h-51v9.8h19.7v49h11.4v-49h19.9V152z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 274.727,
    y1: 210.731,
    x2: 274.727,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281 152.6l19 57.3h-10.4l-4.8-15.6-.2-.6H264l-.2.6-4.5 15.6h-10l18.7-57.3h13m-15.6 34.1h17.7l-.3-1-4.8-14.8-.2-.7c-1-3.1-2-6.6-2.8-9.7l-.2-.6h-1.4l-.2.6-2.2 8c-.2.8-.5 1.7-.7 2.5l-4.7 14.7-.2 1m16.2-34.9h-14.1l-19.3 58.9h11.7l4.7-16.1h19.5l4.9 16.1h12.1l-19.5-58.9zm-15.1 34.1l4.7-14.7 2.9-10.5h.2c.8 3.3 2 7.2 3 10.4l4.8 14.8h-15.6z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.3,210.7v-58.9h11.4v23.4h22.4v-23.4h11.4v58.9h-11.4v-25.5h-22.4v25.5H309.3z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 331.853,
    y1: 210.731,
    x2: 331.853,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.6 152.6v57.3h-9.8v-25.5h-24v25.5H310v-57.3h9.8V176h24v-23.4h9.8m.8-.8H343v23.4h-22.4v-23.4h-11.4v58.9h11.4v-25.5H343v25.5h11.4v-58.9z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 388.979,
    y1: 210.731,
    x2: 388.979,
    y2: 151.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.6 152.6v57.3h-8.8v-18.2c0-9.4.2-17.6.6-25.3v-.7l-1.5-.5-.3.6-9.5 19.7-13.5 24.2h-10.3v-57.3h8.8V170c0 9.6-.3 17.7-1 24.8l-.1.9h1.6l.2-.5c2.4-5.4 5.7-12.5 9.2-19l13.3-23.9h11.3m.8-.5h-12.5l-13.5 24.3c-3.3 6.1-6.5 13-9.3 19h-.2c.7-7.4 1-15.5 1-24.9v-18.4h-10.4v58.9H378l13.7-24.6c3.3-6.1 6.7-13.4 9.6-19.7l.3.1c-.4 7.1-.6 15.3-.6 25.3v19h10.4v-59z",
    fill: "url(#l)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M437.7 113.3l-11.9-17.7 16.6 15.1c3.2 2.9 7.9 3.2 11.5.8l28-18.9-22.9 23.8c-3 3.1-3.5 7.8-1.3 11.5l11.2 17.7-13.1-10.3c-5.6-4.8-13.7-5.5-20-1.5l-19 11.9 19.7-19.7c3.4-3.5 3.9-8.8 1.2-12.7z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M225.1 84.7l5.5 17.1h16.6l-12.5 10.4 3.9 16.1-13.5-7.5-13.5 7.5 4.4-16.1-12.4-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M225.1 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M289.5 85.7l5.2 16.2.1.2h16L299 112l-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m0-1l-4.9 17.1H268l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4H295l-5.5-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M351.8 84.7l5.5 17.1h16.6l-12.4 10.4 3.8 16.1-13.5-7.5-13.4 7.5 4.4-16.1-12.5-10.4h16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M351.9 85.7l5.2 16.2.1.2h16l-11.8 9.9-.1.1v.2l3.7 15.5-12.9-7.1-.1-.1-.1.1-12.9 7.1 4.2-15.4.1-.2-.1-.1-11.8-9.9h16l.1-.2 4.4-16.3m-.1-1l-4.9 17.1h-16.6l12.5 10.4-4.4 16.1 13.5-7.5 13.5 7.5-3.9-16.1 12.5-10.4h-16.6l-5.6-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M191.9 212.8c-2.7 1.4-8.6 2.7-16.2 2.7-20.5 0-31.7-12.4-31.7-29.4 0-18.9 14-30.9 33.1-30.9 7.4 0 12.8 1.4 15.4 2.8l-2.6 9.2c-3-1.3-7.2-2.6-12.6-2.6-12.1 0-21.3 7.5-21.3 20.9 0 12.1 7.8 20.4 21.3 20.4 4.7 0 9.5-.8 12.7-2.3l1.9 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M289.1 210.7l-4.9-16.1h-19.5l-4.7 16.1h-11.7l19.3-58.9h14.1l19.6 58.9h-12.2zm-15-49.9c-.9 3.6-2 7.2-2.9 10.5l-4.7 14.7H282l-4.8-14.8c-1-3.2-2.2-7.1-3-10.4h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M411.4 151.8v58.9H401v-19c0-10 .2-18.2.6-25.3l-.3-.1c-2.9 6.3-6.3 13.6-9.6 19.7L378 210.6h-11.5v-58.9h10.4v18.4c0 9.3-.3 17.5-1 24.9h.2c2.7-6.1 5.9-12.9 9.3-19l13.5-24.3h12.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVipIconBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vip_icon_bg.5baed81b8f79e19c429e880570edcb16.svg";